import React, { useContext } from "react";
import { Tooltip } from "@material-ui/core";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import { WhatsAppsContext } from "../context/WhatsApp/WhatsAppsContext";
import { AuthContext } from "../context/Auth/AuthContext";

// Read-only presentation of the existing company connection state.
export default function ConnectionStatus({ collapsed = false, metaHealth = { records: [] } }) {
  const { whatsApps = [], loading = true } = useContext(WhatsAppsContext) || {};
  const { socket } = useContext(AuthContext);
  const connection = socket?.socket || socket;
  const [socketOnline, setSocketOnline] = React.useState(!!connection?.connected);
  React.useEffect(() => {
    setSocketOnline(!!connection?.connected);
    if (!connection?.on) return undefined;
    const online = () => setSocketOnline(true);
    const offline = () => setSocketOnline(false);
    connection.on("connect", online);
    connection.on("disconnect", offline);
    return () => { connection.off("connect", online); connection.off("disconnect", offline); };
  }, [connection]);
  const connected = whatsApps.filter(w => w.status === "CONNECTED").length;
  const unknown = loading || !socketOnline;
  const partial = connected > 0 && connected < whatsApps.length;
  const blocked = metaHealth.records.some(r => r.status === "blocked");
  const credential = metaHealth.records.some(r => r.status === "credentials");
  const color = blocked || credential ? "#fb7185" : unknown ? "#94a3b8" : partial ? "#fbbf24" : connected ? "#34d399" : "#fb7185";
  const label = blocked ? "API bloqueada pela Meta" : credential ? "Credencial da Meta recusada" : unknown ? "Verificando conexão" : partial ? "Conexão parcial" : connected ? "WhatsApp conectado" : "WhatsApp desconectado";
  const detail = blocked || credential ? "Confira o alerta no sistema" : unknown ? "Aguardando atualização do servidor" : whatsApps.length ? `${connected} de ${whatsApps.length} conexões ativas` : "Nenhuma conexão cadastrada";
  return <Tooltip title={`${label} · ${detail}`} placement="right">
    <div className="j10-connection-status" role="status" aria-live="polite" style={{ color, justifyContent: collapsed ? "center" : undefined }}>
      <WhatsAppIcon style={{ fontSize: 21, flexShrink: 0 }} />
      {!collapsed && <div><strong>{label}</strong><small>{detail}</small></div>}
      {!collapsed && <span className="j10-status-dot" style={{ background: color }} />}
    </div>
  </Tooltip>;
}
